import { Anchor } from "@marketplace/ui";

import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  YouTubeIcon
} from "./icons";

export const Accounts = () => {
  return (
    <div className="flex justify-between items-center gap-x-[18px] text-[#001332]">
      <Anchor
        href="https://www.facebook.com/lintasarta.official"
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 text-inherit"
      >
        <FacebookIcon />
      </Anchor>
      <Anchor
        href="https://www.linkedin.com/company/lintasarta"
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 text-inherit"
      >
        <LinkedInIcon />
      </Anchor>
      <Anchor
        href="https://www.youtube.com/@lintasarta_official"
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 text-inherit"
      >
        <YouTubeIcon />
      </Anchor>
      <Anchor
        href="https://www.instagram.com/lintasarta.official"
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 text-inherit"
      >
        <InstagramIcon />
      </Anchor>
    </div>
  );
};
